<template>
  <div class="VideoHeadText">
      <div class="title">
          <p>{{detailsList.objectname}}
            <span :class="{'video-status': true, 'not-started': detailsList.streamstatus == 0, 'loading-status': detailsList.streamstatus == 1 || detailsList.streamstatus == 2}"><img src="@/common/images/leveing/video/video-status.png" />
                <template v-if="detailsList.streamstatus == 0">未开始</template>
                <template v-if="detailsList.streamstatus == 1">直播中</template>
                <template v-if="detailsList.streamstatus == 2">暂停直播</template>
                <template v-if="detailsList.streamstatus == 10">结束直播</template>
            </span>
            <span class="video-see" v-if="detailsList.streamstatus != 0"><img src="@/common/images/leveing/video/video-see.png" />{{detailsList.viewcount | calaculationFlow}}</span>
            <span class="peySign" v-if="detailsList.feetype === 2">付费</span>
          </p>
      </div>
      <div class="video-name">
          <!-- <span>主办方：{{detailsList.hostname}}</span> -->
          <span>时间：{{detailsList.begintime}}</span>
          <!-- <div class="peySign">付费</div> -->
      </div>
  </div>
  <!-- end 视频直播 顶部标题文本 -->
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'VideoHeadText',
  props: ['detailsList'],
  data () {
    return {}
  },
  mounted () {},
  methods: {
      ...mapActions(['setLoading'])
  },
  filters: {
      calaculationFlow(data = parseInt(data)) {  // 计算流量
      if (data) {
          if (data < 10000) {
              return data
          } else {
              let num = (data / 10000).toString().split("."),
                  leftNum = num[0],
                  rightNum = num[1].substr(0, 1)
  
              return leftNum + "." + rightNum + '万'
              // return (data / 10000).toFixed(1) + '万'
          }
        }
      }
  },
  watch: {},
  computed: {},
  components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.VideoHeadText {
    margin-bottom: 15px;
    .title {
        overflow: hidden;
        p {
            margin-right: 10px;
            color: #333333;
            font-size: 24px;
            line-height: 33px;
        }
        .video-status,
        .video-see, .peySign {
            display: inline-block;
            padding: 0 12px;
            height: 30px;
            line-height: 30px;
            border-radius: 21px;
            font-size: 14px;
            color: #fff;
            transform: translateY(-2px);
            -webkit-transform: translateY(-2px);
            -ms-transform: translateY(-2px);
            -o-transform: translateY(-2px);
            -moz-transform: translateY(-2px);

            &.video-see {
                margin-left: 20px;
                background: #ccc;
            }
            &.video-status {
                margin-left: 10px;
                background: #999999;
                &.loading-status {
                    background: #409EFF;
                }
                &.not-started {
                    background: #FFA904;
                }
            }
            &.peySign {
                margin-left: 20px;
                background: #fdd7d7;
                color: #F56C6C;
            }
            img {
                float: left;
                margin-top: 7px;
                margin-right: 8px;
                width: 16px;
                height: 16px;
            }
        }
    }
    .video-name {
        margin-top: 10px;
        display: flex;
        align-items: center;
        span {
            font-size: 14px;
            & ~ span {
                margin-left: 20px;
            }
        }
        .peySign {
            display: inline-block;
            width: 58px;
            height: 26px;
            background: #fdd7d7;
            border-radius: 2px;
            font-size: 12px;
            color: #F56C6C;
            margin-left: 15px;
            line-height: 26px;
            text-align: center;
        }
    }
}
</style>